import React, { useState } from 'react';
import Header from './header';
import { InputRadio, InputReset, InputText } from 'view/common/elements/input';
import TextBox from 'view/common/elements/textbox';
import Button from 'view/common/elements/button';
import OutlineButton from 'view/common/elements/outlineButton';
import validator from 'validator';
import httpClient from 'httpClient';
import Notification from 'view/common/notification';

const ContactUsForm = (props) => {
  const[firstName, setFirstName] = useState("")
  const[lastName, setLastName] = useState("")
  const[phone, setPhone] = useState("")
  const[email, setEmail] = useState("")
  const[company, setCompany] = useState("")
  const[role, setRole] = useState("")
  const[description, setDescription] = useState("")
  const[preferredMethod, setPreferredMethod] = useState("phone")

  const[firstNameError, setFirstNameError] = useState("")
  const[lastNameError, setLastNameError] = useState("")
  const[phoneError, setPhoneError] = useState("")
  const[emailError, setEmailError] = useState("")
  const[companyError, setCompanyError] = useState("")
  const[roleError, setRoleError] = useState("")
  const[descriptionError, setDescriptionError] = useState("")
  
  const [sending, setSending] = useState(false);

  const preferredMethodChanged = (v) => {
    if(preferredMethod !== v) {
      setPreferredMethod(v)
    }
  }

  const validateValues = () => {
    console.log("1")
    let isValid = true;
    let emptyFieldMsg = "Please fill this field";
    if(firstName.trim() === "") {
      setFirstNameError(emptyFieldMsg);
      isValid = false;
    }
    if(lastName.trim() === "") {
      setLastNameError(emptyFieldMsg);
      isValid = false;
    }
    console.log(email);
    console.log(email.trim());
    if(email.trim() === "") {
      setEmailError(emptyFieldMsg);
      isValid = false;
    } else if (!validator.isEmail(email.trim())) {
      
      setEmailError("Please enter your email");
      isValid = false;
    }
    if(company.trim() === "") {
      setCompanyError(emptyFieldMsg);
      isValid = false;
    }
    if(role.trim() === "") {
      setRoleError(emptyFieldMsg);
      isValid = false;
    }
    if(description.trim() === "") {
      setDescriptionError(emptyFieldMsg);
      isValid = false;
    }
    return isValid;
  }

  const resetValues = () => {
    setFirstName("");
    setLastName("");
    setPhone("");
    setEmail("");
    setCompany("");
    setRole("");
    setDescription("");
    setPreferredMethod("phone")
  }

  const sendData = async () => {
    if(sending) {
      console.log("2")
      return false;
    }
    

    let isValid = validateValues();
    if(!isValid) {
      return;
    }
    setSending(true); 
    const payload = {
      firstName,
      lastName,
      phone,
      email,
      company,
      role,
      description,
      preferredMethod,
    }

    try {
      let response = await httpClient.post("/auth/v1/captureData", payload);
      if(!response.error) {
        Notification.success(`Thank you for your interest in UnitHuman`);
      }
      resetValues();
      
    } catch (ex) {
      Notification.error("An error was encountered")
    } finally {
      setSending(false)
    }
    
    
  }
  
  return ( 
    <div className='flex flex-col'>
      <Header/>
      <div className='bg-uhgray py-5 px-5 pb-30 min-h-screen'>
        <div className='bg-white border rounded rounded-4 py-5 px-5 mb-60 lg:mb-40'>
          <div className='text-2xl text-uhblue-darkest mb-10'>
            Contact Us
          </div>
          <div>
            The UH Platform is available to validated risk management and life insurance professionals.
          </div>
          <div className='mb-10'>
            Fill out the form below to request further access to connect with the UH team. 
            Fields with an asterisk(*) is required.
          </div>
          <form className='w-full lg:w-7/12'>
            <div>
              <div className='w-full lg:w-1/2 inline-block'>
                <div className={`mr-0 lg:mr-2`}>
                  <InputText
                    label={"First Name *"}
                    value={firstName}
                    onChange={setFirstName}
                    error={firstNameError}
                    onFocus={()=>setFirstNameError('')}
                  />
                </div>
              </div>
              <div className='w-full lg:w-1/2 inline-block mt-5 lg:mt-0 '>
                <div className={`ml-0 lg:ml-2`}>
                  <InputText
                    label={"Last Name *"}
                    value={lastName}
                    onChange={setLastName}
                    error={lastNameError}
                    onFocus={()=>setLastNameError('')}
                  />
                </div>
              </div>
            </div>
            <div className='mt-5'>
              <div className='w-full inline-block'>
                <InputText
                  label={"Phone"}
                  value={phone}
                  onChange={setPhone}
                  error={phoneError}
                  onFocus={()=>setPhoneError('')}
                />
              </div>
              
            </div>
            <div className='mt-5'>
              <div className='w-full inline-block'>
                <InputText
                  label={"Email *"}
                  value={email}
                  onChange={setEmail}
                  error={emailError}
                  onFocus={()=>setEmailError('')}
                />
              </div>
              
            </div>
            <div className='mt-5'>
              <div className='w-full inline-block'>
                <InputText
                  label={"Company *"}
                  value={company}
                  onChange={setCompany}
                  error={companyError}
                  onFocus={()=>setCompanyError('')}
                />
              </div>
            </div>
            <div className='mt-5'>
              <div className='w-full inline-block'>
                <InputText
                  label={"Role *"}
                  value={role}
                  onChange={setRole}
                  error={roleError}
                  onFocus={()=>setRoleError('')}
                />
              </div>
            </div>
            <div className='mt-5'>
              <div className='w-full  inline-block'>
              <TextBox
                content={description}
                height={8}
                onChange={setDescription}
                name="Description"
                label="Description *"
                error={descriptionError}
                onFocus={()=>setDescriptionError('')}
                className={`mb-10`}
              />
              </div>
            </div>
            <div className='flex justify-between w-full mb-10'>
              <Button
                text="Send"
                onClick={sendData}
              />
              <OutlineButton
                text="Reset"
                onClick={()=>{}}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
    
  ) 
}

export default ContactUsForm;